export default __webpack_public_path__ + "static/media/border-2.decebfd2.webp";